import React from "react";
import Logo from "../Assets/Logo.svg";
import { BsTwitter } from "react-icons/bs";
import { SiLinkedin } from "react-icons/si";
import { BsYoutube } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";
import { Link } from "react-router-dom";
import { navigation_constants } from "../constants/navigation.constants";

const Footer = () => {
	return (
		<div className="footer-wrapper">
			<div className="footer-section-one">
				<div className="footer-logo-container">
					<h2>S E C R E T S</h2>
				</div>
				<div className="footer-icons">
					{/* <BsTwitter /> */}
					<SiLinkedin />
					{/* <BsYoutube /> */}
					{/* <FaFacebookF /> */}
				</div>
			</div>
			<div className="footer-section-two">
				<div className="footer-section-columns">
					{/* <span>244-5333-7783</span> */}
					<a className="footer-section-child" href="mailto:varselcorp@gmail.com?subject=Hello&body=This%20is%20the%20email%20body">Contact Us</a>
				</div>
				<div className="footer-section-columns">
					<Link className="footer-section-child" to={navigation_constants.pages.tos}>Terms of Service</Link>
					<Link className="footer-section-child" to={navigation_constants.pages.privacy_policy}>Privacy Policy</Link>
				</div>
			</div>
		</div>
	);
};

export default Footer;
